(function() {
  function formatCentsToMoney(centsText) {
    try {
      const cents = Number(centsText);
      const value = cents / 100;
      const currency = (window?.Shopify?.currency || {}).active || undefined;
      return new Intl.NumberFormat(undefined, { style: 'currency', currencyDisplay: 'symbol', currency }).format(value);
    } catch {
      return '$' + (Number(centsText) / 100).toFixed(2);
    }
  }

  function updateInstallments(container, variant) {
    if (!container || !variant) return;
    const divisor = Number(container.dataset.divisor || '4');
    const threshold = Number(container.dataset.threshold || '5000');
    const priceCents = Number(variant.price || 0);

    if (!priceCents || priceCents < threshold) {
      container.hidden = true;
      return;
    }

    const perCents = Math.round(priceCents / divisor);
    const amountEl = container.querySelector('.installments-message__amount');
    if (amountEl) {
      amountEl.textContent = formatCentsToMoney(perCents);
      amountEl.classList.add('money');
      amountEl.setAttribute('data-amount-cents', String(perCents));
    }

    container.hidden = false;

    if (window?.Currency?.convertAll) {
      try { window.Currency.convertAll(); } catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('currency:refresh'));
  }

  function bindListeners(scope) {
    const root = scope || document;
    const section = root.querySelector('.shopify-section.product-information, .shopify-section');
    if (!section) return;

    section.addEventListener('variant:update', function(e) {
      const variant = e?.detail?.resource || e?.detail?.variant || null;
      const container = section.querySelector('.installments-message');
      updateInstallments(container, variant);
    });

    const container = section.querySelector('.installments-message');
    if (container) {
      const priceEl = section.querySelector('[data-product-price], .price-item--regular');
      if (priceEl) {
        const num = Number(String(priceEl.textContent).replace(/[^0-9.]/g, ''));
        if (Number.isFinite(num)) {
          updateInstallments(container, { price: Math.round(num * 100) });
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindListeners());
  } else {
    bindListeners();
  }
})();


